import { render, staticRenderFns } from "./dwdf.vue?vue&type=template&id=66972c5f&"
import script from "./dwdf.vue?vue&type=script&lang=js&"
export * from "./dwdf.vue?vue&type=script&lang=js&"
import style0 from "./dwdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports